import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useApi } from "@/lib/api";
import { money } from "./helpers";

const MESI = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"];
const label = (m) => `${MESI[Number(m.slice(5, 7)) - 1]} ${m.slice(2, 4)}`;

// Revenue vs collected per month (last 12 months) for the current sheet filters (search one customer to see only them).
export default function MonthlyChart({ tid, params, tick }) {
  const api = useApi();
  const [d, setD] = useState(null);
  useEffect(() => {
    const { month, date_from, date_to, ...rest } = params;
    api.get(`/t/${tid}/crm/monthly`, { params: { ...rest, months: 12 } }).then(({ data }) => setD(data)).catch(() => setD(null));
  }, [api, tid, params, tick]);
  if (!d) return null;
  const data = d.series.map((s) => ({ m: label(s.month), Revenue: s.revenue / 100, Incassato: s.cash / 100 }));
  return (
    <div className="rounded-lg border bg-white p-3" data-testid="sheet-monthly">
      <p className="mb-2 text-xs text-slate-600">Ultimi 12 mesi · Revenue <b className="text-slate-900" data-testid="sheet-monthly-revenue">{money(d.totals.revenue)}</b> · Incassato <b className="text-emerald-700" data-testid="sheet-monthly-cash">{money(d.totals.cash)}</b>
        <span className="ml-2 text-slate-400">Ogni addebito nel suo mese (rinnovi compresi). Per un solo cliente usa la ricerca.</span></p>
      <div className="h-56"><ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
          <XAxis dataKey="m" tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 11 }} width={72} tickFormatter={(v) => `${v.toLocaleString("it-IT")} €`} />
          <Tooltip formatter={(v) => money(Math.round(v * 100))} /><Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="Revenue" fill="#0f172a" radius={[3, 3, 0, 0]} /><Bar dataKey="Incassato" fill="#059669" radius={[3, 3, 0, 0]} />
        </BarChart></ResponsiveContainer></div>
    </div>
  );
}
